import React from 'react';
import './getButton.css';

export const BlueButton = (props) => <button className="blue-button" {...props} />;
export const DisableButton = (props) => <button className="disable-button" {...props} />;
export const DullButton = (props) => <button className="dull-button" {...props} />;
export const LitButton = (props) => <button className="lit-button" {...props} />;
export const EventButton = (props) => <button className="event-button" {...props} />;
